import { render, staticRenderFns } from "./UserInfoDetail.vue?vue&type=template&id=16d98498&scoped=true"
import script from "./UserInfoDetail.vue?vue&type=script&lang=js"
export * from "./UserInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./UserInfoDetail.vue?vue&type=style&index=0&id=16d98498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d98498",
  null
  
)

export default component.exports